// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitFormController from "./autosubmit_form_controller"
application.register("autosubmit-form", AutosubmitFormController)

import AutoShowModalController from "./auto_show_modal_controller"
application.register("auto-show-modal", AutoShowModalController)

import BadwordUploaderController from "./badword_uploader_controller"
application.register("badword-uploader", BadwordUploaderController)

import ChartsController from "./charts_controller"
application.register("charts", ChartsController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatepickerAutosubmitController from "./datepicker_autosubmit_controller"
application.register("datepicker-autosubmit", DatepickerAutosubmitController)

import DateRangeFilterController from "./filters/date_range_filter_controller"
application.register("date-range-filter", DateRangeFilterController)

import PeriodFilterController from "./filters/period_filter_controller"
application.register("period-filter", PeriodFilterController)

import MultipleTomSelectFilterController from "./filters/multiple_tom_select_filter_controller"
application.register("multiple-tom-select-filter", MultipleTomSelectFilterController)

import RadioFilterController from "./filters/radio_filter_controller"
application.register("radio-filter", RadioFilterController)

import ReportReasonController from "./report_reason_controller"
application.register("report-reason", ReportReasonController)

import CheckboxFilterController from "./filters/checkbox_filter_controller"
application.register("checkbox-filter", CheckboxFilterController)

import TomSelectFilterController from "./filters/tom_select_filter_controller"
application.register("tom-select-filter", TomSelectFilterController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SsoSettingsController from "./sso_settings_controller"
application.register("sso-settings", SsoSettingsController)

import StreamLinkNoticeController from "./stream_link_notice_controller"
application.register("stream-link-notice", StreamLinkNoticeController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TurboFrameReloadController from "./turbo_frame_reload_controller"
application.register("turbo-frame-reload", TurboFrameReloadController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TopicsCloudController from "./topics_cloud_controller"
application.register("topics-cloud", TopicsCloudController)

import UniversityDeletionController from "./university_deletion_controller"
application.register("university-deletion", UniversityDeletionController)

import UniversityPermissionToggleController from "./university_permission_toggle_controller"
application.register("university-permission-toggle", UniversityPermissionToggleController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import PreloadVisibilityController from "./preload_visibility_controller"
application.register("preload-visibility", PreloadVisibilityController)

import PasswordVisibility from "@stimulus-components/password-visibility"
application.register("password-visibility", PasswordVisibility)

import CharacterCounter from "./custom_character_counter_controller"
application.register("character-counter", CharacterCounter)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StickyColumnsController from "./sticky_columns_controller"
application.register("sticky-columns", StickyColumnsController)

import ScrollIndicatorController from "./scroll_indicator_controller"
application.register("scroll-indicator", ScrollIndicatorController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import PasswordEditController from "./password_edit_controller"
application.register("password-edit", PasswordEditController)

import PostSigninFlowController from "./post_signin_flow_controller"
application.register("post-signin-flow", PostSigninFlowController)

import PostCommentsDrawerController from "./post_comments_drawer_controller"
application.register("post-comments-drawer", PostCommentsDrawerController)

import MarketingConsentController from "./marketing_consent_controller"
application.register("marketing-consent", MarketingConsentController)

import ToggleHiddenController from "./toggle_hidden_controller"
application.register("toggle-hidden", ToggleHiddenController)

import SpeakerJoinInstructionsController from "./speaker_join_instructions_controller"
application.register("speaker-join-instructions", SpeakerJoinInstructionsController)

import ReInviteSpeakerController from "./re_invite_speaker_controller"
application.register("re-invite-speaker", ReInviteSpeakerController)

import ResetPasswordSpeakerController from "./reset_password_speaker_controller"
application.register("reset-password-speaker", ResetPasswordSpeakerController)

import WidgetFilterController from "./widget_filter_controller"
application.register("widget-filter", WidgetFilterController)

import WidgetFiltersListController from "./widget_filters_list_controller"
application.register("widget-filters-list", WidgetFiltersListController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import DeleteProfileController from "./delete_profile_controller"
application.register("delete-profile", DeleteProfileController)

import DropdownButtonController from "./dropdown_button_controller"
application.register("dropdown-button", DropdownButtonController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import BrokenImageController from "./broken_image_controller"
application.register("broken-image", BrokenImageController)

import TableCheckboxesController from "./table_checkboxes_controller"
application.register("table-checkboxes", TableCheckboxesController)

import TableFloatingPanelController from "./table_floating_panel_controller"
application.register("table-floating-panel", TableFloatingPanelController)

import DeleteAmbassadorsController from "./delete_ambassadors_controller"
application.register("delete-ambassadors", DeleteAmbassadorsController)

import AddTagsController from "./add_tags_controller"
application.register("add-tags", AddTagsController)

import DisableFunctionalityController from "./disable_functionality_controller"
application.register("disable-functionality", DisableFunctionalityController)

import UpdateTimeLimitsController from "./update_time_limits_controller"
application.register("update-time-limits", UpdateTimeLimitsController)

import OpenDrawerController from "./open_drawer_controller"
application.register("open-drawer", OpenDrawerController)

import ExportCsvController from "./export_csv_controller"
application.register("export-csv", ExportCsvController)

import ContentAccordionController from "./content_accordion_controller"
application.register("content-accordion", ContentAccordionController)

import ContentSpinnerController from "./content_spinner_controller"
application.register("content-spinner", ContentSpinnerController)

import InviteUsersController from "./invite_users_controller"
application.register("invite-users", InviteUsersController)

import KeyboardShortcutController from "./keyboard_shortcut_controller"
application.register("keyboard-shortcut", KeyboardShortcutController)

import ManageContentsActionsController from "./manage_contents_actions_controller"
application.register("manage-contents-actions", ManageContentsActionsController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import DialogsSearchController from "./dialogs_search_controller"
application.register("dialogs-search", DialogsSearchController)

import ActiveStateController from "./active_state_controller"
application.register("active-state", ActiveStateController)

import VideoUploadController from "./video_upload_controller"
application.register("video-upload", VideoUploadController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import SearchSelectController from "./search_select_controller"
application.register("search-select", SearchSelectController)

import DialogMessagesController from "./dialog_messages_controller"
application.register("dialog-messages", DialogMessagesController)

import TextareaAutogrow from "stimulus-textarea-autogrow"
application.register("textarea-autogrow", TextareaAutogrow)

import SendMessageController from "./send_message_controller"
application.register("send-message", SendMessageController)

import TimepickerController from "./timepicker_controller"
application.register("timepicker", TimepickerController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import PinnedMessagesController from "./pinned_messages_controller"
application.register("pinned-messages", PinnedMessagesController)


import DialogListController from "./dialog_list_controller"
application.register("dialog-list", DialogListController)

import ExternalSpeakerValidationController from "./external_speaker_validation_controller"
application.register("external-speaker-validation", ExternalSpeakerValidationController)

import ExternalSpeakersFormController from "./external_speakers_form_controller"
application.register("external-speakers-form", ExternalSpeakersFormController)

import ManageStreamController from "./manage_stream_controller"
application.register("manage-stream", ManageStreamController)

import StreamHeartbeatController from "./stream_heartbeat_controller"
application.register("stream-heartbeat", StreamHeartbeatController)

import InviteToChatController from "./invite_to_chat_controller"
application.register("invite-to-chat", InviteToChatController)

import InviteToStreamController from "./invite_to_stream_controller"
application.register("invite-to-stream", InviteToStreamController)

import CreateCommunitySpaceController from "./create_community_space_controller"
application.register("create-community-space", CreateCommunitySpaceController)

import openCreateCommunitySpaceModalController from "./open_create_community_space_modal_controller"
application.register("open-create-community-space-modal", openCreateCommunitySpaceModalController)

import InviteProspectsController from "./invite_prospects_controller"
application.register("invite-prospects", InviteProspectsController)

import TagsInputController from "./tags_input_controller"
application.register("tags-input", TagsInputController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormChangeDetectorController from "./form_change_detector_controller"
application.register("form-change-detector", FormChangeDetectorController)

import OpenCreateCommunitySpaceModalController from "./open_create_community_space_modal_controller"
application.register("open-create-community-space-modal", OpenCreateCommunitySpaceModalController)

import ParseEmailsFileController from "./parse_emails_file_controller"
application.register("parse-emails-file", ParseEmailsFileController)

import CreateChatFormController from "./create_chat_form_controller"
application.register("create-chat-form", CreateChatFormController)

import CommunitySpaceSelectController from "./community_space_select_controller"
application.register("community-space-select", CommunitySpaceSelectController)

import DataCollectionSpaceSelectController from "./data_collection_space_select_controller"
application.register("data-collection-space-select", DataCollectionSpaceSelectController)

import IdpPublishTagsController from "./idp_publish_tags_controller"
application.register("idp-publish-tags", IdpPublishTagsController)

import ImpactConversionOutcomeController from "./impact_conversion_outcome_controller"
application.register("impact-conversion-outcome", ImpactConversionOutcomeController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import SendRelevantContentController from "./send_relevant_content_controller"
application.register("send-relevant-content", SendRelevantContentController)

import BarPositionController from "./bar_position_controller"
application.register("bar-position", BarPositionController)

import NumberInputController from "./number_input_controller"
application.register("number-input", NumberInputController)

import ControlActionButtonController from "./control_action_button_controller"
application.register("control-action-button", ControlActionButtonController)

import DrawerSideCardController from "./drawer_side_card_controller"
application.register("drawer-side-card", DrawerSideCardController)

import PopcardPreviewController from "./popcard_preview_controller"
application.register("popcard-preview", PopcardPreviewController)

import CarouselPreviewController from "./carousel_preview_controller"
application.register("carousel-preview", CarouselPreviewController)

import AnswerClampController from "./answer_clamp_controller"
application.register("answer-clamp", AnswerClampController)

import FeedbackExportController from "./feedback_export_controller"
application.register("feedback-export", FeedbackExportController)

import DownloadFileController from "./download_file_controller"
application.register("download-file", DownloadFileController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ContentRequestController from "./content_request_controller"
application.register("content-request", ContentRequestController)

import ContentUploadController from "./content_upload_controller"
application.register("content-upload", ContentUploadController)

import ContentUploadTriggerController from "./content_upload_trigger_controller"
application.register("content-upload-trigger", ContentUploadTriggerController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import NestedChatsController from "./nested_chats_controller"
application.register("nested-chats", NestedChatsController)

import TrackedLinkPreviewController from "./tracked_link_preview_controller"
application.register("tracked-link-preview", TrackedLinkPreviewController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import DragDropController from "./drag_drop_controller"
application.register("drag-drop", DragDropController)

import UploaderController from "./uploader_controller"
application.register("uploader", UploaderController)

import UploaderModalController from "./uploader_modal_controller"
application.register("uploader-modal", UploaderModalController)

import SsoLoginController from "./sso_login_controller"
application.register("sso-login", SsoLoginController)

import MergeTagsController from "./merge_tags_controller"
application.register("merge-tags", MergeTagsController)

import TextEditorController from "./text_editor_controller"
application.register("text-editor", TextEditorController)

import BulkActionsPanelController from "./bulk_actions_panel_controller"
application.register("bulk-actions-panel", BulkActionsPanelController)

import EditInputController from "./edit_input_controller"
application.register("edit-input", EditInputController)

import QuestionListController from "./optional_questions/question_list_controller"
application.register("question-list", QuestionListController)

import QuestionController from "./optional_questions/question_controller"
application.register("question", QuestionController)

import AnswerCsvUploadController from "./optional_questions/answer_csv_upload_controller"
application.register("answer-csv-upload", AnswerCsvUploadController)

import DialogViewToggleController from "./dialog_view_toggle_controller"
application.register("dialog-view-toggle", DialogViewToggleController)

import ChatSidebarController from "./chat_sidebar_controller"
application.register("chat-sidebar", ChatSidebarController)

import LiveEventController from "./live_event_controller"
application.register("live-event", LiveEventController)

import LiveEventSettingsAccordionController from "./live_event_settings_accordion_controller"
application.register("live-event-settings-accordion", LiveEventSettingsAccordionController)

import LiveEventTimeFilterController from "./live_event_time_filter_controller"
application.register("live-event-time-filter", LiveEventTimeFilterController)

import SafeguardingCounterController from "./safeguarding_counter_controller"
application.register("safeguarding-counter", SafeguardingCounterController)

import SafeguardingCasesBulkActionsController from "./safeguarding_cases_bulk_actions_controller"
application.register("safeguarding-cases-bulk-actions", SafeguardingCasesBulkActionsController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import UrlEmailCleanupController from "./url_email_cleanup_controller"
application.register("url-email-cleanup", UrlEmailCleanupController)

import StudySubjectCsvUploadController from "./study_subject_csv_upload_controller"
application.register("study-subject-csv-upload", StudySubjectCsvUploadController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import TimeMinutesSecondsController from "./time_minutes_seconds_controller"
application.register("time-minutes-seconds", TimeMinutesSecondsController)

import UrlSyncController from "./url_sync_controller"
application.register("url-sync", UrlSyncController)

import ProfileTypeFieldsController from "./profile_type_fields_controller"
application.register("profile-type-fields", ProfileTypeFieldsController)

import AmbassadorTypeFieldsController from "./ambassador_type_fields_controller"
application.register("ambassador-type-fields", AmbassadorTypeFieldsController)

import AmbassadorChildController from "./ambassador_child_controller"
application.register("ambassador-child", AmbassadorChildController)

import AmbassadorChildrenController from "./ambassador_children_controller"
application.register("ambassador-children", AmbassadorChildrenController)
